import React from "react"
import styled from "styled-components/macro"
import * as Adm from "@adm"
import { CircularProgress } from "@material-ui/core"
function Spinner() {
  return <Adm.BrandLoadingBar />
}
export default Spinner
